import { FilterFilled, SearchOutlined, SyncOutlined } from "@ant-design/icons";
import { PageHeader } from "@ant-design/pro-layout";
import {
  Button,
  Col,
  Divider,
  Modal,
  notification,
  Popover,
  Row,
  Space,
  Spin,
  Table,
  Tag,
} from "antd";
import { ColumnsType } from "antd/lib/table";
import { BaseType } from "antd/lib/typography/Base";
import dayjs from "dayjs";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Bill from "../../../components/common/bill";
import SCard from "../../../components/common/card";
import { FilterPartnerTree as FilterPartner } from "../../../components/common/companyfilter";
import {
  CheckOutList,
  FeedbackStatusList,
  filterItems,
  getDiffTime,
  ModeList,
  NoneItemsList,
  PayStatus,
  StatusNumList,
} from "../../../components/common/history-filter-data";
import QrCode from "../../../components/common/qrcode";
import {
  StatusFilterTree,
  TextFilter,
  TimerFilter,
} from "../../../components/common/statusfilter";
import SwitchTags from "../../../components/common/switchtags";
import Filter from "../../../components/filter";
import { Page } from "../../../constants/common";
import {
  isComplate,
  ItemNames,
  PayModeMap,
  ServeModes,
  StatisticsDataType,
  TabledServe,
} from "../../../constants/serve";
import Requestor from "../../../requestor";
import { getUser } from "../../../states/user/user.reducer";
import Detail from ".././history/details";

// 序号对应存储该筛选条件的位置
const FilterItemkeyList: string[] = [
  "license",
  "createdAt",
  "mode",
  "provider",
  "driverCompany",
  "status",
  "feedback",
  "paystatus",
  "noneItems",
  "phone",
  "billmode",
  "providerOutNo",
  "checked_out",
];
const FilterItemIndexMap = new Map<string, number>(
  FilterItemkeyList.map((key, index) => [key, index]),
); //方便查询每个筛选条件对应的索引
const AloneKeys = ["billmode", "paystatus"];

type FilterItem = {
  name: string;
  values: (string | number)[];
  where: string;
  reset: (() => void) | undefined;
};

type historyFilterProps = {
  license?: string;
  phone?: string;
  registNo?: string;
  provider: string; //
  driverCompany?: string; //救援企业
  status?: number;
  mode?: number;
  // paymentStatus: number,//支付状态
  createdAt?: [dayjs.Dayjs, dayjs.Dayjs];
  billmode?: string;
};

type IProps = {};
let Timer: NodeJS.Timeout | null = null;
const History: React.FC<IProps> = (props: IProps) => {
  const [Services, pageTabledServices] = useState<Page<TabledServe>>({
    page: 1,
    size: 15,
    payload: [],
    total: 0,
  });
  const [sp, updateSp] = React.useState(false);
  const [detailId, setDetailId] = useState<string | null>(null);
  const [showBill, setShowBill] = React.useState<string | false>(false);
  const [statisticsData, setstatisticsData] =
    React.useState<StatisticsDataType | null>(null); //统计数据
  const [filterState, setFilterState] = React.useState<boolean[]>(
    FilterItemkeyList.map((item) => false),
  ); //数据对饮关系参照FilterItemIndexMap true代表该项目存在筛选， false代表无筛选
  const [payStatusList, setPayStatusList] = React.useState<
    { title: string; key: number }[]
  >([]); //存储支付筛选条件，跟随支付模式变化
  const tabStr = useRef<string>();
  const statisTime = useRef<{
    start: number | undefined;
    end: number | undefined;
  }>({ start: undefined, end: undefined });
  const filters = useRef<(FilterItem | undefined)[]>([]); //筛选叫车人和服务人\服务状态\支付或者挂账状态，存储序号和FilterItemIndexMap对应

  const User = useSelector(getUser)!;
  const Navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (User === null) {
      Navigate("/login");
    }
  }, [User, Navigate]);

  useEffect(() => {
    const { search } = location;
    if (!search) return;
    const _key = search.split("=")[1];
    onFilterChange("checked_out", [+_key]);
  }, []);

  const financialStatistics = React.useCallback(
    async (start?: number, end?: number) => {
      if (start && end) {
        statisTime.current.start = start;
        statisTime.current.end = end;
      }

      try {
        const res = await Requestor.financialStatistics<StatisticsDataType>(
          statisTime.current.start,
          statisTime.current.end,
        );
        if (res.error !== "") {
          throw new Error(res.error);
        }

        setstatisticsData(res.result);
      } catch (e) {
        console.log(e);
      }
    },
    [],
  );

  const pageServices = React.useCallback(
    async (page = 1, size = 15, isAutoRef?: boolean) => {
      if (isAutoRef !== true) {
        updateSp(true);
      }

      // AloneKeys是特殊处理的筛选条件，单独传参
      let wheres: string[] = filters.current
        .filter((t) => t && t.where !== "" && !AloneKeys.includes(t.name))
        .map((item) => item!.where);
      let paystatus =
        filters.current[FilterItemIndexMap.get("paystatus")!]?.where;
      let billmode =
        filters.current[FilterItemIndexMap.get("billmode")!]?.where;

      if (tabStr.current) {
        wheres.push(tabStr.current);
      }

      if (!!billmode) {
        paystatus = paystatus ? `${paystatus}&${billmode}` : billmode;
      }

      let whereStr = wheres.join(" AND ");

      try {
        const res = await Requestor.pageServices<Page<TabledServe>>(
          page,
          size,
          encodeURIComponent(whereStr),
          paystatus,
        );
        if (res.error !== "") {
          throw new Error(res.error);
        }
        pageTabledServices(res.result);

        if (Timer) {
          clearTimeout(Timer);
        }
        Timer = setTimeout(() => {
          pageServices(page, size, true);
        }, 1000 * 30);
      } catch (e) {
        console.log(e);
        notification.error({
          message: "获取调度列表失败",
          description: `失败原因：${e}`,
        });
      } finally {
        if (isAutoRef !== true) {
          updateSp(false);
        }
        financialStatistics();
      }
    },
    [pageTabledServices],
  );

  React.useEffect(() => {
    pageServices(1, 15);

    return () => {
      if (Timer) {
        clearTimeout(Timer);
      }
    };
  }, []);

  const onFilterComplete = React.useCallback(
    async (values: historyFilterProps) => {
      let { license, phone, registNo, billmode, driverCompany } = values;
      registNo = registNo?.trim();

      if (registNo && registNo !== "") {
        onFilterChange("providerOutNo", [registNo], "", false);
      } else {
        onResetFilter("providerOutNo", false, false);
      }

      if (license !== undefined) {
        onFilterChange("license", license ? [license] : [], "", false);
      } else {
        onResetFilter("license", false, false);
      }

      if (phone !== undefined) {
        onFilterChange("phone", phone ? [phone] : [], "", false);
      } else {
        onResetFilter("phone", false, false);
      }

      if (billmode !== undefined) {
        let mode = parseInt(billmode);
        let lis = [...PayStatus];
        if (mode === 0) {
          lis = lis.splice(0, 2);
        } else if (mode === 1) {
          lis = lis.splice(2, 2);
        } else if (mode === 2) {
          lis = lis.splice(4, 4);
        }

        // 此处重置之前的选择
        // let billmodeIndex = FilterItemIndexMap.get("paystatus")
        onResetFilter("paystatus", false, false);
        setPayStatusList(lis);
        onFilterChange("billmode", [mode], `billmode=${mode}`, false);
      }

      if (driverCompany !== undefined) {
        let id = parseInt(driverCompany);
        onFilterChange(
          "driverCompany",
          [id],
          id > 0
            ? `\`driverCompany\` = ${id}`
            : `\`driverCompany\` != ${Math.abs(id)}`,
          false,
        );
      }

      if (
        registNo ||
        billmode != undefined ||
        driverCompany ||
        phone ||
        license
      ) {
        pageServices();
      }
    },
    [],
  );

  /**
   * 表格筛选条件变化的处理
   * @param  key 筛选项name
   * @param  values 筛选的values
   * @param  where_str 筛选where， 如果传了where，代表前面的values不需要处理
   */
  const onFilterChange = useCallback(
    (
      key: string,
      values: (string | number)[],
      where_str: string = "",
      needUpdate: boolean = true,
    ) => {
      let index = FilterItemIndexMap.get(key);
      if (index === undefined) return;
      if (values.length < 1) {
        filters.current[index] = undefined;
        setFilterState(
          filters.current.map(
            (item) => item !== undefined && item.values.length > 0,
          ),
        );
        if (needUpdate) {
          pageServices();
        }
        return;
      }

      let wherestr: string = "";

      const simpleSql = (k: string, v: string | number) =>
        typeof v === "number"
          ? `\`${key}\` = ${v}`
          : `\`${key}\` like '%${v}%'`;
      if (where_str !== undefined && where_str !== "") {
        wherestr = where_str;
      } else {
        if (values.length === 1) {
          wherestr = simpleSql(key, values[0]);
        } else {
          wherestr = `(${values.map((v) => simpleSql(key, v)).join(" OR ")})`;
        }
      }

      filters.current[index] = {
        name: key,
        values: values,
        where: wherestr,
        reset: filters.current[index]?.reset,
      };
      setFilterState(
        filters.current.map(
          (item) => item !== undefined && item.values.length > 0,
        ),
      );
      if (needUpdate) {
        pageServices();
      }
    },
    [],
  );

  const onResetFilter = useCallback(
    (key: string, isall: boolean = false, needUpdate: boolean = true) => {
      if (isall) {
        filters.current = filters.current.map((item) => {
          if (item?.reset) item.reset();
          return undefined;
        });
      } else {
        let index = FilterItemIndexMap.get(key);
        if (index === undefined) return;
        let item = filters.current[index];
        if (item?.reset) {
          item.reset();
        }
        filters.current[index] = undefined;
      }
      setFilterState(
        filters.current.map(
          (item) => item !== undefined && item.values.length > 0,
        ),
      );
      if (needUpdate) {
        pageServices();
      }
    },
    [],
  );

  const registerReset = useCallback((key: string, fun: () => void) => {
    let index = FilterItemIndexMap.get(key);
    if (index === undefined) return;

    let ori = filters.current[index];
    filters.current[index] = {
      name: ori?.name || "",
      where: ori?.where || "",
      values: ori?.values || [],
      reset: fun,
    };
  }, []);

  const deCheckedOut = location.search
    ? +location.search.split("=")[1]
    : undefined;
  const columns: ColumnsType<TabledServe> = React.useMemo(() => {
    const Icon = (mode: string) => (
      <FilterFilled
        style={{
          color: filterState[FilterItemIndexMap.get(mode)!]
            ? "#40a9ff"
            : "gray",
        }}
      />
    );
    return [
      {
        title: "序号",
        dataIndex: "createdAt",
        width: 30,
        render: (time: number, item, index) => {
          let isToday =
            dayjs(time * 1000)
              .startOf("day")
              .format("X") === dayjs().startOf("day").format("X");
          return <Tag color={isToday ? "green" : "default"}>{index + 1}</Tag>;
        },
      },
      {
        title: "车牌号码",
        dataIndex: "license",
        filterIcon: Icon("license"),
        filterDropdown: () => {
          return (
            <TextFilter
              skey="license"
              label="车牌号"
              registerReset={registerReset.bind(this, "license")}
              onChange={onFilterChange.bind(this, "license")}
            />
          );
        },
      },
      {
        title: "派单时间",
        dataIndex: "createdAt",
        filterIcon: Icon("createdAt"),
        filterDropdown: () => (
          <TimerFilter
            registerReset={registerReset.bind(this, "createdAt")}
            onChange={(times) => {
              if (times.length === 2) {
                const start = times[0].startOf("day").format("X");
                const end = times[1].endOf("day").format("X");
                onFilterChange(
                  "createdAt",
                  [start, end],
                  `(\`createdAt\` >= ${start} AND \`createdAt\` <= ${end})`,
                );
              } else {
                onFilterChange("createdAt", []);
              }
            }}
          />
        ),
        render: (time: number, record) => {
          if (!time) {
            return "";
          }

          const overTime = 5;
          let ctime = dayjs(time * 1000).format("YYYY-MM-DD HH:mm");

          let { diffTime, diffminute } = getDiffTime(time);
          let type: BaseType = "secondary";

          if (record.status < 4 && diffminute > overTime) {
            type = "danger";
          }

          return <span>{ctime}</span>;
          /* return <Popover title="" content={
          <div>
            <p>已派单时长:{diffminute < (60 * 24) && <Typography.Text mark={type === "danger"} type={type}>{diffTime}</Typography.Text>}</p>
            {type === "danger" && <Typography.Text type="danger">超时未联系客户</Typography.Text>}
          </div>
        }>
          <Space>
            <span>{ctime}</span>
            {diffminute < (60 * 24) && <Typography.Text mark={type === "danger"} type={type}>{diffTime}</Typography.Text>}
          </Space>
        </Popover> */
        },
      },
      {
        title: "救援模式",
        dataIndex: "mode",
        filterIcon: Icon("mode"),
        filterDropdown: () => (
          <StatusFilterTree
            multiple={false}
            treeData={ModeList}
            registerReset={registerReset.bind(this, "mode")}
            onChange={onFilterChange.bind(this, "mode")}
          />
        ),
        render: (mode: number) =>
          mode !== undefined ? ServeModes[mode].replace("救援", "") : "暂无",
      },
      /* {
      title: "叫车人",
      dataIndex: "provider",
      filterIcon: Icon('provider'),
      filterDropdown: () => (
        <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
          <FilterPartner name="provider" onChange={(id) => { onFilterChange(`provider`, id) }} registerReset={registerReset.bind(this, 'provider')} ></FilterPartner>
        </div>
      ),
      render: (value, item) => {
        let name = value.replace("中国人民财产保险股份有限公司", "人保")
        name = name.replace("中国平安财产保险股份有限公司", "平安")
        return <div> <Popover content={<Button type="link" icon={<SearchOutlined />} onClick={() => onFilterChange(`provider`, [item.providerId])} >查看此公司数据</Button>} >{name}</Popover></div>;
      }
    }, */
      {
        title: "服务公司",
        dataIndex: "driverCompany",
        filterIcon: Icon("driverCompany"),
        filterDropdown: () => (
          <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
            <FilterPartner
              name="driverCompany"
              onChange={onFilterChange.bind(this, "driverCompany")}
              registerReset={registerReset.bind(this, "driverCompany")}
            ></FilterPartner>
          </div>
        ),
        render: (value, item) => {
          let name = value.replace("贵州拖车侠科技服务有限公司", "拖车侠");
          return (
            <div>
              <Popover
                content={
                  <Button
                    type="link"
                    icon={<SearchOutlined />}
                    onClick={() =>
                      onFilterChange(`driverCompany`, [item.driverCompanyId])
                    }
                  >
                    查看此公司数据
                  </Button>
                }
              >
                {name}
              </Popover>
            </div>
          );
        },
      },
      {
        title: "保险公司",
        dataIndex: "provider",
        filterIcon: Icon("provider"),
        filterDropdown: () => (
          <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
            <FilterPartner
              name="provider"
              onChange={onFilterChange.bind(this, "provider")}
              registerReset={registerReset.bind(this, "provider")}
            ></FilterPartner>
          </div>
        ),
        render: (value, item) => {
          let name = value.replace("贵州拖车侠科技服务有限公司", "拖车侠");
          return (
            <div>
              <Popover
                content={
                  <Button
                    type="link"
                    icon={<SearchOutlined />}
                    onClick={() =>
                      onFilterChange(`provider`, [item.providerId])
                    }
                  >
                    查看此公司数据
                  </Button>
                }
              >
                {name}
              </Popover>
            </div>
          );
        },
      },
      {
        title: "客户电话",
        dataIndex: "phone",
        filterIcon: Icon("phone"),
        filterDropdown: () => {
          return (
            <TextFilter
              skey="phone"
              label="客户电话"
              registerReset={registerReset.bind(this, "phone")}
              onChange={onFilterChange.bind(this, "phone")}
            />
          );
        },
      },
      {
        title: "空单",
        dataIndex: "items",
        filterIcon: Icon("noneItems"),
        filterDropdown: () => (
          <StatusFilterTree
            registerReset={registerReset.bind(this, "noneItems")}
            multiple={false}
            treeData={NoneItemsList}
            onChange={(keys) => {
              let key = keys[0];
              let where = "";
              if (key === 0) {
                where = `json_length(\`items\`)=0`;
              } else if (key === 1) {
                where = `json_length(\`items\`)>0`;
              }
              onFilterChange("noneItems", keys, where);
            }}
          />
        ),
        render: (items: object) => {
          let keys = Object.keys(items);
          let isEmpty = keys.length < 1;
          let itemnames = keys
            .map((k) => ItemNames.get(Number(k)))
            .filter((k) => k != undefined);
          return isEmpty ? (
            <Tag color="red">是</Tag>
          ) : (
            <Popover content={itemnames.join("; ")}>
              <Tag color="green">否</Tag>
            </Popover>
          );
        },
      },
      {
        title: "支付状态",
        dataIndex: "paymentMode",
        // filterIcon: Icon('paystatus'),
        /* filterDropdown: () => (
        <StatusFilterTree registerReset={registerReset.bind(this, 'paystatus')} multiple={false} treeData={payStatusList} onChange={(keys) => {
          let status = keys[0];
          let where = getPayStatusParam(Number(status));
          onFilterChange('paystatus', keys, where)
        }} />
      ), */
        render: (p: number, item) => (
          <Popover content={PayModeMap[p]}>
            {isComplate(item) ? (
              <Tag
                color="success"
                style={{ cursor: "pointer" }}
                title="点击查看账单"
                onClick={() => {
                  setShowBill(item.sid);
                }}
              >
                已完成
              </Tag>
            ) : (
              <Tag color="red">未完成</Tag>
            )}
          </Popover>
        ),
      },
      {
        title: "救援状态",
        dataIndex: "status",
        filterIcon: Icon("status"),
        filterDropdown: () => (
          <StatusFilterTree
            registerReset={registerReset.bind(this, "status")}
            multiple={false}
            treeData={StatusNumList}
            onChange={(keys) => {
              let status = keys[0];
              let wherestr = "";
              if (status === 1) {
                wherestr = `(${`\`status\` > 5`})`;
              } else if (status === 2) {
                wherestr = `(${`\`status\` < 6`})`;
              }
              onFilterChange("status", keys, wherestr);
            }}
          />
        ),
        render: (status: number) => {
          if (status > 5) {
            return <Tag color="success">已完成</Tag>;
          }
          return <Tag color="red">未完成</Tag>;
        },
      },
      /* {
      title: "服务状态",
      dataIndex: "statusText",
      filterIcon: Icon('status'),
      filterDropdown: () => (
        <StatusFilterTree registerReset={registerReset.bind(this, 'status')} multiple={true} treeData={StatusList} onChange={(keys) => {
          onFilterChange('status', keys)
        }} />
      ),
      render: (text: string, item: TabledServe) => {
        if (text.includes("人保")) {
          return <Tag color="red">{text}</Tag>
        }
        return text.replace(/^驾驶员/, "").replace(/^服务/, "")
      },
    },  */
      {
        title: "结算状态",
        dataIndex: "checkedOut",
        filterIcon: Icon("checked_out"),
        filterDropdown: () => (
          <StatusFilterTree
            registerReset={registerReset.bind(this, "checked_out")}
            multiple={false}
            treeData={CheckOutList}
            defaultSelectKey={deCheckedOut}
            onChange={(keys) => {
              onFilterChange("checked_out", keys);
            }}
          />
        ),
        render: (status: boolean) => {
          if (status) {
            return <Tag color="success">已结算</Tag>;
          }
          return <Tag color="default">未结算</Tag>;
        },
      },
      {
        title: "状态",
        dataIndex: "feedback",
        filterIcon: Icon("feedback"),
        filterDropdown: () => (
          <StatusFilterTree
            multiple={false}
            registerReset={registerReset.bind(this, "feedback")}
            treeData={FeedbackStatusList}
            onChange={(keys) => {
              onFilterChange(
                "feedback",
                keys,
                `\`feedback\` = ${keys[0] === 1}`,
              );
            }}
          />
        ),
        render: (feedback: boolean) =>
          feedback ? (
            <Tag color="success">已审核</Tag>
          ) : (
            <Tag color="default">未审核</Tag>
          ),
      },
      {
        title: "操作",
        render: (item: TabledServe) => {
          const buttons = [
            <Button
              type="link"
              key={`details-${item.sid}`}
              // onClick={() => navigate(`/details/${item.sid}`)}
              onClick={() => {
                setDetailId(item.sid);
              }}
            >
              详情
            </Button>,
            // <RemarkAddComp key={"mark-" + item.sid} sid={item.sid} onComplete={() => { pageServices(Services.page, Services.size) }} license={item.license}>跟单</RemarkAddComp>,
          ];

          buttons.push(
            <QrCode
              key={"qcode-" + item.sid}
              sid={item.sid}
              license={item.license}
            />,
          );

          return <Space>{buttons}</Space>;
        },
      },
    ];
  }, [Services, payStatusList]);

  const onTabchange = useCallback(
    (e: string) => {
      let tab = parseInt(e);
      if (tab === 0) {
        tabStr.current = "";
      } else {
        tabStr.current = `\`dispatcher\` = ${tab}`;
      }
      pageServices(Services.page, Services.size);
    },
    [Services, pageServices],
  );

  const ListPage = () => (
    <div className={detailId === null ? "" : "hidden"}>
      <PageHeader
        title=""
        subTitle={
          <SwitchTags
            onChoose={({ start, end }) => {
              financialStatistics(start, end);
            }}
          />
        }
        ghost={false}
        extra={[
          <Button
            key="refresh"
            type="primary"
            icon={<SyncOutlined spin={sp} />}
            onClick={() => pageServices(Services.page, Services.size)}
          >
            刷新
          </Button>,
        ]}
      >
        <Row>
          <Col span={24}>
            {statisticsData && (
              <Row gutter={10}>
                <Col span={4}>
                  <SCard
                    label="应挂账总额"
                    value={statisticsData.creditedTotalFee / 100}
                    prefix="￥"
                    suffix={`${statisticsData.creditedTotalNumber}单`}
                  ></SCard>
                </Col>
                <Col span={4}>
                  <SCard
                    label="已挂帐"
                    value={statisticsData.creditedFee / 100}
                    prefix="￥"
                    suffix={`${statisticsData.creditedNumber}单`}
                  ></SCard>
                </Col>
                <Col span={4}>
                  {" "}
                  <SCard
                    label="待挂账"
                    value={statisticsData.noCreditFee / 100}
                    prefix="￥"
                    suffix={`${statisticsData.noCreditNumber}单`}
                  ></SCard>
                </Col>
                <Col span={4}>
                  <SCard
                    label="应支付总额"
                    value={statisticsData.payTotalFee / 100}
                    prefix="￥"
                    suffix={`${statisticsData.payTotalNumber}单`}
                  ></SCard>
                </Col>
                <Col span={4}>
                  {" "}
                  <SCard
                    label="已支付"
                    value={statisticsData.paidFee / 100}
                    prefix="￥"
                    suffix={`${statisticsData.paidNumber}单`}
                  ></SCard>
                </Col>
                <Col span={4}>
                  <SCard
                    label="待支付"
                    value={statisticsData.unpaidFee / 100}
                    prefix="￥"
                    suffix={`${statisticsData.unpaidNumber}单`}
                  ></SCard>
                </Col>
              </Row>
            )}
          </Col>
          <Divider />
          <Col span={24}>
            <Filter
              autoSubmit={true}
              items={filterItems}
              onComplete={onFilterComplete}
              onReset={() => {
                onResetFilter("", true);
              }}
            />
          </Col>
        </Row>
      </PageHeader>
      {/* <Tabs onChange={onTabchange} items={[{ key: '0', label: "全部" }, { key: `${User.id}`, label: "我的调度单" }]}>
    </Tabs> */}
      <Table
        // loading={sp}
        rowKey="sid"
        columns={columns}
        dataSource={Services.payload}
        pagination={{
          current: Services.page,
          pageSize: Services.size,
          total: Services.total,
          onChange: (page, size) => pageServices(page, size),
          showSizeChanger: true,
          showTotal: (total: number, range: [number, number]) =>
            `共${total}条记录，当前第${range[0]}-${range[1]}条`,
        }}
      />
    </div>
  );

  return (
    <Spin spinning={sp} tip="请稍后...">
      {ListPage()}
      {detailId && (
        <Detail sid={detailId} goBack={() => setDetailId(null)}></Detail>
      )}
      <Modal
        title=""
        width={1024}
        open={showBill !== false}
        footer={null}
        style={{ top: 24 }}
        onCancel={() => setShowBill(false)}
        destroyOnClose
        maskClosable={false}
      >
        {showBill && <Bill sid={showBill} onComplete={() => {}} />}
      </Modal>
    </Spin>
  );
};

export default History;
